import { axios } from "../../helper/axios";
import { NetworkTableconstant } from "./NetworkTableConstant";

const NetworkTableApi = {};

NetworkTableApi.getNetworkTable = ({
  from_date,
  to_date,
  search_term,
  page,
  limit,
}) => {
  
  let queryParam = "";

  if (page) {
    queryParam += `page=${page}&`;
  }
  if (search_term) {
    queryParam += `search_term=${encodeURIComponent(search_term)}&`;
  }
  if (from_date && to_date) {
    queryParam += `startDate=${from_date}&endDate=${to_date}&`;
  }
  if (limit) {
    queryParam += `limit=${limit}&`;
  }

  

  return axios.get(`${NetworkTableconstant.NETWORK_TABLE_API}?${queryParam}`);
};

// bulk excel export 
NetworkTableApi.getNetworkBulkExportTable = ({
 
  limit,
}) => {
  
  let queryParam = "";

  if (limit) {
    queryParam += `limit=${limit}&`;
  }

  

  return axios.get(`${NetworkTableconstant.NETWORK_TABLE_API}?${queryParam}`);
};

// *********post********
NetworkTableApi.postChargingNetworkApi = (payload) => {

  return axios.post(NetworkTableconstant.POST_ADD_CHARGING_NETWORK_API,payload );
};
//enable desable api

NetworkTableApi.AddChargingNetworkEnableDisableApi = ({ id, status }) => {
  return axios.put(NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_API, {
    id: id,
    status: status,
  });
};

// update api
NetworkTableApi.UpdateChargingNetworkApi = (payload) => {

  return axios.put(NetworkTableconstant.UPDATE_CHARGING_NETWORK_API, payload);
};

NetworkTableApi.DeleteNetworkApi = (id ) => { 
  return axios.delete(
    NetworkTableconstant.DELETE_CHARGING_NETWORK_API.replace(":id", id)
  );
};

export { NetworkTableApi };
